import React from "react";
import NewsletterEight from "../component/NewsletterEight";

function NewsletterEightContainers() {
  return <NewsletterEight />;
}

export default NewsletterEightContainers;
